import { TMemberState } from '@/redux/reducers/member';
import { TGetMemberByMobileSuccess } from '@/redux/actions/member';

export const getMemberByMobileUpdateState = (state: TMemberState, action: TGetMemberByMobileSuccess): TMemberState => ({
  ...state,
  getMemberByMobileResponse: action.payload.response,
});
